import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/sendService/sendAccount/select`,
    method: "POST",
    data,
  });
}

// 新增
export function addApi(data) {
  return request({
    url: `/sendService/sendAccount/add`,
    method: "POST",
    data,
  });
}

/* 修改 */
export function updateApi(data) {
  return request({
    url: `/sendService/sendAccount/update`,
    method: "POST",
    data,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/sendService/sendAccount/delete`,
    method: "POST",
    data,
  });
}
